import { StatusCodes, buildLoginRedirectUrl } from "@knowfully/ui.common";
import axios from "axios";
import { API_ORGANIZATION_ID } from "config/headers";
import { ADMIN_BASE_URL } from "config/paths";
import { ResponseCode } from "services/KnowfullyAdminClient";
import authStore from "stores/authStore";
import { OrganizationContextStorage } from "utils/organizationContextStorage";

const axiosInstance = axios.create({
  baseURL: ADMIN_BASE_URL,
  headers: {
    "X-API-ORGANIZATION-ID": API_ORGANIZATION_ID,
    "X-Requested-With": "XMLHttpRequest",
  },
});

const createNoContentResponse = () => ({ status: StatusCodes.NO_CONTENT });

axiosInstance.interceptors.request.use((config) => {
  const contextStore = OrganizationContextStorage.get();
  if (contextStore?.organizationId) {
    config.headers["X-API-ORGANIZATION-ID"] = contextStore.organizationId;
  }
  const userId = authStore.getRawState().id;
  if (userId) {
    config.headers["X-API-ADMIN-USER-ID"] = userId;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (
      response?.data?.responseCode === ResponseCode.BusinessRuleFailed ||
      response?.data?.responseCode === ResponseCode.ValidationFailed
    ) {
      return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    const status = error.status ?? error.response?.status;

    if (status === StatusCodes.UNAUTHORIZED) {
      window.location.replace(buildLoginRedirectUrl(window.location.pathname));
      return Promise.resolve(createNoContentResponse());
    }

    if (status === StatusCodes.FORBIDDEN && window.location.pathname !== "/unauthorized") {
      window.location.href = "/unauthorized";
      return Promise.resolve(createNoContentResponse());
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
